export enum projectRoutes {
	actualCosts = 'actual-costs',
	applicationRates = 'application-rates',
	attachments = 'attachments',
	boqExport = 'boq-export',
	charge = 'charge',
	charges = 'charges',
	comment = 'comment',
	projectCosts = 'costs',
	discounts = 'discounts',
	emails = 'emails',
	export = 'export',
	inclusionsExclusions = 'inclusions-exclusions',
	scope = 'scope',
	invoice = 'invoice',
	labourCosts = 'labour-costs',
	officeFolder = 'office-folder',
	overview = 'overview',
	policies = 'policies',
	procedures = 'procedures',
	productPurchasing = 'product-purchasing',
	qaFolder = 'qa-folder',
	quote = 'quote',
	quoteProposal = 'quote-proposal',
	siteFolder = 'site-folder',
	subcontracting = 'subcontracting',
	tasks = 'tasks',
	tenderDocument = 'tender-document',
	time = 'time',
	variationQuote = 'variation-quote',
	variations = 'variations',
	versions = 'versions',
	safetyFolder = 'safety-folder',
	productFolder = 'product-folder',
}
